import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const EmptyState = ({
  icon = 'Inbox',
  headline = 'No data yet',
  explanation = 'Get started by adding your first item',
  ctaText = 'Get Started',
  ctaIcon = 'Plus',
  onCtaClick,
  className = ''
}) => {
  return (
    <div className={`flex items-center justify-center min-h-[60vh] px-4 ${className}`}>
      <div className="bg-white rounded-2xl sm:rounded-3xl border border-gray-200 shadow-sm p-6 sm:p-8 md:p-12 text-center max-w-2xl w-full relative">
        {/* Decorative Icons */}
        <div className="absolute top-6 left-6 sm:top-8 sm:left-8 md:top-12 md:left-12 animate-float">
          <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full bg-cyan-100 flex items-center justify-center">
            <Icon name="Camera" size={16} color="#06B6D4" className="sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px]" />
          </div>
        </div>
        <div className="absolute top-6 right-6 sm:top-8 sm:right-8 md:top-12 md:right-16 animate-float-delayed">
          <Icon name="Sparkles" size={20} color="#FBBF24" className="sm:w-[22px] sm:h-[22px] md:w-[24px] md:h-[24px]" />
        </div>

        {/* Main Icon with Gradient Background */}
        <div className="relative inline-block mb-6 sm:mb-8">
          {/* Outer glow circle */}
          <div className="absolute inset-0 bg-gradient-to-br from-purple-200 to-blue-200 rounded-full blur-xl sm:blur-2xl opacity-40 scale-110"></div>
          {/* Middle circle */}
          <div className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 rounded-full bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center">
            {/* Inner circle with icon */}
            <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center">
              <Icon name={icon} size={32} color="#FFFFFF" className="sm:w-[36px] sm:h-[36px] md:w-[40px] md:h-[40px]" />
            </div>
          </div>
        </div>

        {/* Headline */}
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
          {headline}
        </h2>

        {/* Explanation Text */}
        <p className="text-sm sm:text-base md:text-lg text-gray-500 leading-relaxed mb-6 sm:mb-8 max-w-lg mx-auto">
          {explanation}
        </p>

        {/* CTA Button */}
        {onCtaClick && (
          <button
            onClick={onCtaClick}
            className="inline-flex items-center justify-center gap-2 sm:gap-3 px-6 py-3 sm:px-8 sm:py-4 bg-gradient-to-r from-purple-600 to-cyan-500 text-white font-semibold text-base sm:text-lg rounded-xl sm:rounded-2xl hover:opacity-90 transition-opacity shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform duration-200"
          >
            <Icon name={ctaIcon} size={20} color="#FFFFFF" className="sm:w-[22px] sm:h-[22px] md:w-[24px] md:h-[24px]" />
            {ctaText}
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;